var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"lz-editor-input"},[_c('div',{staticClass:"formulate-input-label"},[_vm._v(_vm._s(_vm.label))]),_c('label',{staticClass:"formulate-input-subtitle"},[_vm._v(_vm._s(_vm.subtitle))]),_c('vue-editor',{staticClass:"lz-editor-input__quill",attrs:{"value":_vm.value},on:{"input":_vm.onInput}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }